import { render, staticRenderFns } from "./IconSvgBinoculars.vue?vue&type=template&id=3ce9f4bf&scoped=true&"
import script from "./IconSvgBinoculars.vue?vue&type=script&lang=js&"
export * from "./IconSvgBinoculars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce9f4bf",
  null
  
)

export default component.exports